import React, { useEffect, useState } from "react";
import Select from "react-select";
import LaboratoryService from "../../../../services/LaboratoireService";
export default function (props) {
  const { filters, setFilters } = props;
  const [options, setOptions] = useState([]);
  const [coursiers_ids, setCoursiersIds] = useState([]);
  const [initialValues, setInitialVallues] = useState();
  const [coursiers, setCoursiers] = useState([]);

  const userIdHandler = (value) => {
    let ids = [];
    value.map((sv) => {
      ids.push(sv.value);
    });
    setCoursiersIds(ids);
    let lcoursiers = [];
    coursiers.map((c) => {
      if (ids.includes(c.id)) {
        console.log("existe");
        lcoursiers.push(c);
      }
    });
    setFilters({
      ...filters,
      coursiers: lcoursiers,
    });

    console.log("options ===>", options, ids, lcoursiers, coursiers);
  };
  const getCoursiers = async () => {
    try {
      const response = await LaboratoryService.couriersAll();
      if (response.status === 200) {
        console.log("coursiers list ===>", response.data.data);
        setCoursiers(response.data.data);
        let ids = [];
        let loptions = [];
        let lcoursiers = [];
        response.data.data.map((d) => {
          loptions.push({
            value: d.id,
            label: d.last_name + " " + d.first_name,
          });
          ids.push({
            value: d.id,
            label: d.last_name + " " + d.first_name,
          });

          lcoursiers.push(d);
        });
        setOptions(loptions);
        setInitialVallues(ids);
      

       
      }
    } catch (err) {
      // console.log(err);
    }
  };

  useEffect(() => {
    getCoursiers();
  }, []);

  return (
    <>
      <div className="mt-2">
        <h4>Coursiers </h4>
        <div className="mt-2">
          {options && options.length > 0 ? (
            <Select
              defaultValue={options}
              name="coursier"
              onChange={userIdHandler}
              options={options}
              isMulti
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
}
